import React from 'react'
import { string, object, number, func } from 'prop-types'
import { PROFESSIONALS, PROJECTS, TYPES_WITH_FOLLOW_BUTTON, ARTICLE_ARCHIVE } from '../../utils/constants'
import Icon from '../ui/icon/Icon'

const DynamicTitlesAndDescriptions = ({
  dynamicTitle,
  totalCount,
  showMatchedResults,
  description,
  type,
  renderFollowButton,
  filtersObject,
  aggregationActive
}) => {
  const onlyDesktopClass = type !== PROFESSIONALS ? 'afd-desktop-e' : ''

  return (
    <div className={`search-header__row search-header__row--with-metadata search-header__row--${type}`}>
      <div className={`search-header__title-button-container search-header__title--${type}`}>
        {type === ARTICLE_ARCHIVE && !filtersObject.topic && <Icon svg='archive' withoutHover withoutFill />}
        <h1 className='search-header__heading'>
          {dynamicTitle}
          {((!Object.keys(filtersObject).includes('companies') && type === PROJECTS) ||
            ![PROJECTS, ARTICLE_ARCHIVE].includes(type)) &&
            <span className={`search-header__results ${onlyDesktopClass}`}>
              {totalCount && `${totalCount.toLocaleString('en-US')} `}
              {showMatchedResults}
            </span>
          }
        </h1>
        {
          TYPES_WITH_FOLLOW_BUTTON.includes(aggregationActive) &&
          Object.keys(filtersObject).length > 0 &&
          renderFollowButton(filtersObject, aggregationActive)}
      </div>
      <p className='search-header__description'>{description}</p>
    </div >
  )
}

DynamicTitlesAndDescriptions.propTypes = {
  dynamicTitle: string,
  totalCount: number,
  showMatchedResults: object,
  description: string,
  type: string,
  renderFollowButton: func,
  filtersObject: object,
  aggregationActive: string
}

export default DynamicTitlesAndDescriptions